import moment from 'moment';
import { EventManager } from '../../controls/calendar/EventManager';
import { ScheduleInterview } from '../action/scheduleInterview/scheduleInterview';

class AdminCalendarController {

    static $inject = ['$scope', '$uibModal', 'dialogs', 'Auth', 'Event'];

    eventManager: EventManager;
    scheduleInterviewAction: ScheduleInterview;

    public viewDateEvents: Event[];

    constructor(
        private $scope: angular.IScope,
        private $uibModal,
        private dialogs,
        private Auth,
        private Event) {

        this.eventManager = new EventManager(Auth, Event);

        this.$scope.$watchGroup([() => this.eventManager.events, () => this.eventManager.viewDate],
            (newValues, oldValues) => {
                let events: any[] = newValues[0];
                const startOfDay: moment.Moment = newValues[1];
                const endOfDay: moment.Moment = moment(startOfDay).endOf('day');

                events = events || [];

                this.viewDateEvents = events.filter((d) => !startOfDay.isAfter(d.endsAt) && !endOfDay.isBefore(d.startsAt));
            });
    }

    addInterview() {
        const interviewDate = moment(this.eventManager.viewDate).add(12, 'hours').toDate();
        const scheduleInterviewAction = new ScheduleInterview(this.$uibModal, {
            agencyId: this.Auth.user.roleDetails.agencyId,
            userId: this.Auth.user.userId,
            interviewerId: this.Auth.user.roleDetails.contactId,
            dateStart: interviewDate,
            attendingUsers: [this.Auth.user.userId]
        });
        scheduleInterviewAction
            .execute()
            .then(() => this.eventManager.reloadEvents());
    }

    canInterviewBeScheduled() {
        const today = new Date();
        const date = new Date(today.getFullYear(), today.getMonth(), today.getDate()).valueOf();
        const selectedDate = moment(this.eventManager.viewDate).toDate().valueOf();
        return selectedDate >= date;
    }

    remove(event) {
        return this.dialogs
            .confirm('Please confirm.', 'Please confirm that you want to remove event.')
            .result
            .then(() => this.Event.remove({ id: event.id }).$promise)
            .then(() => this.eventManager.reloadEvents());
    }

    edit(event){
        const interviewer = event.event.attendingUsers.find(x => x.isOwner);

        if((interviewer && interviewer.id) !== this.Auth.user.userId){
            return;
        }

        const applicant = event.event.attendingUsers.find(x => !x.isOwner);

        if(!applicant){
            return;
        }

        const interview = {
            Id: event.id,
            entryType: event.event.entryType,
            agencyId: event.event.agencyId,
            userId: interviewer.id,
            dateStart: event.event.dateStart,
            time: moment(event.event.dateStart).format('HH:mm'),
            duration: moment.duration(moment(event.event.dateEnd).diff(moment(event.event.dateStart))).asMinutes(),
            notes: event.event.notes,
            applicantUserId: applicant.id,
            applicantName: `${applicant.firstName} ${applicant.lastName}`,
            attendingUsers: event.event.attendingUsers.map(x => x.id)
        };

        let action = new ScheduleInterview(this.$uibModal, interview);
        return action.execute();
    }

    filterAttendees = (attendee) => attendee.id !== this.Auth.user.userId;
    isOwner = (attendee) => attendee.id === this.Auth.user.userId;

}

angular
    .module('app')
    .controller('AdminCalendarController', AdminCalendarController);
